import { SearchForm } from '@calendly/form';
import { useOnValueChange, useQueryParams } from '@calendly/hooks';
import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FiltersButton } from 'features/event_types_filters';
import { isObjectLevelPermissionsAvailableSelector } from 'features/object_level_permissions';
import { isMultipleSelector } from 'selectors/current_organization';
const containerIsPhoneCss = "c339bke";
const containerCss = "cjmr5rr";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const searchFormWrapperIsPhoneCss = "s1hw81iz";
const searchFormWrapperCss = "sobog3i";
const SearchFormWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(searchFormWrapperCss, {
    [searchFormWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const SearchFilter = () => {
  const queryParams = useQueryParams();
  const {
    filter_term: initialValue
  } = queryParams;
  const [searchTerm, setSearchTerm] = useState();
  const history = useHistory();
  const isMultipleOrganization = useSelector(isMultipleSelector);
  const userHasObjectLevelPermissions = useSelector(isObjectLevelPermissionsAvailableSelector);
  useOnValueChange(searchTerm, () => {
    const newParams = {
      ...queryParams
    };
    delete newParams.page;
    if (searchTerm) {
      newParams.filter_term = searchTerm;
    } else {
      delete newParams.filter_term;
    }
    history.push({
      search: buildQuery(newParams)
    });
  });
  const placeHolder = I18n.t('publisher.scheduling.meeting_types.search.placeholder');
  return <Container>
      <SearchFormWrapper>
        <SearchForm id="event-types-search" initialValue={initialValue} placeholder={placeHolder} onSearch={setSearchTerm} data-calendly-label="search-field" />
      </SearchFormWrapper>
      {isMultipleOrganization && userHasObjectLevelPermissions && <FiltersButton scopeOverride="all_users" />}
    </Container>;
};

require("./search_filter.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_filter.js");